// Module
var code = "<button fg-field-input class=\"hide-runner not-clickable waves-effect waves-light btn green\" id=\"{{ field.$_id }}\" type=\"submit\" tabindex=\"{{ tabIndex }}\" ng-model=\"form.data[field.schema.name]\"> {{ field.schema.displayName }} <i class=\"fa-light fa-paper-plane\"></i> </button> ";
// Exports
export default code;